var map = {
	"./mobile/Ellipse2.png": "./src/components/LandingPages/images/openFlo/mobile/Ellipse2.png",
	"./tab/Ellipse2.png": "./src/components/LandingPages/images/openFlo/tab/Ellipse2.png",
	"./web/Ellipse2.png": "./src/components/LandingPages/images/openFlo/web/Ellipse2.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/LandingPages/images/openFlo sync recursive ^.*Ellipse2\\.png$";